import { ReactNode } from "react";
import Loader from "../../../common/Loader";
import { useDeepLinkSetup } from "../../../../hooks";
import { useUserContext } from "../../../../contexts/UserContext";

interface DeepLinkInitializerProps {
  children: ReactNode;
}

const DeepLinkInitializer = ({
  children,
}: DeepLinkInitializerProps): JSX.Element => {
  // Reads /:department/:setupKey URL params and triggers setup selection.
  // On /home route, isDeepLink is false and this is a no-op.
  const { isDeepLink } = useDeepLinkSetup();
  const { isFetchingUserData } = useUserContext();

  if (isDeepLink && isFetchingUserData) {
    return <Loader />;
  }

  return <>{children}</>;
};

export default DeepLinkInitializer;
